import {
  GET_BILLS,
  GET_BILLS_FAIL,
  GET_BILLS_SUCCESS,
  GET_BILL_DETAIL,
  ADD_NEW_BILL,
  ADD_BILL_SUCCESS,
  ADD_BILL_FAIL,
  UPDATE_BILL,
  UPDATE_BILL_SUCCESS,
  UPDATE_BILL_FAIL,
  GET_BILL_DETAIL_FAIL,
  GET_BILL_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
  DELETE_BILL,
  DELETE_BILL_SUCCESS,
  DELETE_BILL_FAIL,
  UPDATE_BILL_ACCESS,
  UPDATE_BILL_ACCESS_SUCCESS,
  UPDATE_BILL_ACCESS_FAIL,
  GET_BILLS_ERRORS,
  GET_BILLS_ERRORS_SUCCESS,
  GET_BILLS_ERRORS_FAIL,
  GET_EXPORT_BILLS,
  GET_EXPORT_BILLS_SUCCESS,
  GET_EXPORTED_BILLS_FAIL,
  RESET_EXPORT_DATA,
  GET_BILLS_FORMATTED_ERRORS,
  GET_BILLS_FORMATTED_ERRORS_SUCCESS,
  GET_BILLS_FORMATTED_ERRORS_FAIL,
  CLEAN_BILL_ERRORS,
} from "./actionTypes"

export const getBills = payload => ({
  type: GET_BILLS,
  payload,
})

export const getBillsSuccess = Bills => ({
  type: GET_BILLS_SUCCESS,
  payload: Bills,
})

export const addNewBill = Bill => ({
  type: ADD_NEW_BILL,
  payload: Bill,
})

export const addBillSuccess = Bill => ({
  type: ADD_BILL_SUCCESS,
  payload: Bill,
})

export const addBillFail = error => ({
  type: ADD_BILL_FAIL,
  payload: error,
})

export const updateBill = Bill => ({
  type: UPDATE_BILL,
  payload: Bill,
})

export const updateBillSuccess = Bill => ({
  type: UPDATE_BILL_SUCCESS,
  payload: Bill,
})

export const updateBillFail = error => ({
  type: UPDATE_BILL_FAIL,
  payload: error,
})

export const getBillsFail = error => ({
  type: GET_BILLS_FAIL,
  payload: error,
})

export const getBillDetail = BillId => ({
  type: GET_BILL_DETAIL,
  BillId,
})

export const getBillDetailSuccess = BillDetails => ({
  type: GET_BILL_DETAIL_SUCCESS,
  payload: BillDetails,
})

export const getBillDetailFail = error => ({
  type: GET_BILL_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})

export const deleteBill = Bill => ({
  type: DELETE_BILL,
  payload: Bill,
})

export const deleteBillSuccess = Bill => ({
  type: DELETE_BILL_SUCCESS,
  payload: Bill,
})

export const deleteBillFail = error => ({
  type: DELETE_BILL_FAIL,
  payload: error,
})

export const updateBillAccess = Bill => ({
  type: UPDATE_BILL_ACCESS,
  payload: Bill,
})

export const updateBillAccessSuccess = Bill => ({
  type: UPDATE_BILL_ACCESS_SUCCESS,
  payload: Bill,
})

export const updateBillAccessFail = error => ({
  type: UPDATE_BILL_ACCESS_FAIL,
  payload: error,
})

export const getBillErrors = payload => ({
  type: GET_BILLS_ERRORS,
  payload,
})

export const cleanBillError = (payload) => ({
  type: CLEAN_BILL_ERRORS,
  payload,
})

export const getBillErrorsSuccess = Bills => ({
  type: GET_BILLS_ERRORS_SUCCESS,
  payload: Bills,
})

export const getBillErrorsFail = error => ({
  type: GET_BILLS_ERRORS_FAIL,
  payload: error,
})

export const getBillFormattedErrors = payload => ({
  type: GET_BILLS_FORMATTED_ERRORS,
  payload,
})

export const getBillFormattedErrorsSuccess = Bills => ({
  type: GET_BILLS_FORMATTED_ERRORS_SUCCESS,
  payload: Bills,
})

export const getBillFormattedErrorsFail = error => ({
  type: GET_BILLS_FORMATTED_ERRORS_FAIL,
  payload: error,
})

export const getExportBills = payload => ({
  type: GET_EXPORT_BILLS,
  payload,
})

export const getExportBillsSuccess = bills => ({
  type: GET_EXPORT_BILLS_SUCCESS,
  payload: bills,
})

export const getExportBillsFail = error => ({
  type: GET_EXPORTED_BILLS_FAIL,
  payload: error,
})

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
})

